import { Loading } from './index';
import React, {useEffect} from 'react';
import {apiInterceptors} from '@src/services/api';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {setRequestCount} from "@src/store/slice/appSettingsSlice";

const ApiProvider = ({ children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { loadingState, requestCount, showLoader } = useSelector((state) => state?.appSettings);

  useEffect(() => {
    apiInterceptors(dispatch, history);
  }, []);

  useEffect(() => {
    if (requestCount < 0) {
      dispatch(setRequestCount(0));
    }
  }, [requestCount]);

  const showSpinning = showLoader || (loadingState && requestCount > 0);
  return <Loading spinning={showSpinning}>{children}</Loading>;
};

export default ApiProvider;
